module.exports = __webpack_public_path__ + "static/media/athack.ecd899ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spoon/athack.jpg
// module id = 144
// module chunks = 0